
export const JobSummaryValidation = (formData, submissionType = "0") => {
    const errors = {};

    debugger;
    if (!formData.CustomerID || formData.CustomerID === "0") {
        errors.CustomerID = 'This field is required';
    }
    if (!formData.FK_ClientBranch_ID || formData.FK_ClientBranch_ID === "0") {
        errors.FK_ClientBranch_ID = 'This field is required';
    }
    if (!formData.FK_ClientContact_ID || formData.FK_ClientContact_ID === "0") {
        errors.FK_ClientContact_ID = 'This field is required';
    }
    if (!formData.IssueTitle.trim()) {
        errors.IssueTitle = 'This field is required';
    }
    if (submissionType === "2") {
        if (!formData.Solution.trim()) {
            errors.Solution = 'This field is required';
        }
    }
    return errors;
};
